import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ContractComment.Delete.IRequest;
type Response = Api.Core.ContractComment.Delete.IResponse;
type Headers = Api.Core.ContractComment.Delete.IHeaders;
const url = '/api/Sales/ContractComment/:id';
export default async function contractCommentDeleteApi({ id }: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
